import { t } from "i18next";
import Condition from "../../components/HangingProtocol/Condition";
import { FormikProvider } from "formik";

const Prerequisite = (props) => {
  const {
    values,
  } = props.formik;
  return (
    <FormikProvider value={props.formik}>
      <div className="tab-section">
      <div>
        <div className="form-section-header">
          <p>{t("hanging-protocol.study-prerequisite")}</p>
        </div>
        <Condition
          formik = {props.formik}
          metaTagOptions = {props.studyPrerequisiteOptions}
          conditionOperandOptions = {props.conditionOperandOptions}
          name="studyPrerequisiteList"
          conditionList = {values['studyPrerequisiteList']}
          action={props.action}
          allErrors={props.allErrors}
          type={t("hanging-protocol.study-prerequisite")}
          autoFocus={true}
          required={true}
          />
      </div>
      </div>
    </FormikProvider>
  );
};

export default Prerequisite;
